export const YIELD_ASSET_PICKER_PATH = "/wallet/yields/pick-asset";
